import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { baseReviewabilityDefaults } from '../constants/Reviewability';
import * as UnreviewableReasons from '../constants/UnreviewableReason';
const profileReviewabilityDefaults = Object.assign({
  hasProfile: null,
  emptyPortal: null,
  minimumPortalAge: null
}, baseReviewabilityDefaults);
export default class ProfileReviewability extends createImmutableObjectClass(profileReviewabilityDefaults) {
  getUnreviewableReason() {
    const {
      hubSpotter,
      maxPortalReviews,
      portalReviewsCount,
      testPortal,
      userOnProviderPortal,
      userAlreadyReviewed,
      emptyPortal,
      minimumPortalAge
    } = this;

    if (hubSpotter) {
      return UnreviewableReasons.HUBSPOTTER;
    } else if (portalReviewsCount >= maxPortalReviews) {
      return UnreviewableReasons.LIMIT_REACHED;
    } else if (userOnProviderPortal) {
      return UnreviewableReasons.PROVIDER_USER;
    } else if (testPortal) {
      return UnreviewableReasons.TEST_PORTAL_USER;
    } else if (userAlreadyReviewed) {
      return UnreviewableReasons.ALREADY_REVIEWED;
    } else if (emptyPortal) {
      return UnreviewableReasons.EMPTY_PORTAL;
    } else if (!minimumPortalAge) {
      return UnreviewableReasons.MIN_PORTAL_AGE;
    } else {
      return false;
    }
  }

  isReviewable() {
    return !this.getUnreviewableReason();
  }

}